import { makeActionCreator } from '../../../utilities'
import { DefaultsConstants } from './defaults.constants'

export const setProcedureDefaults = makeActionCreator(DefaultsConstants.SET_PROCEDURE_DEFAULTS, 'defaults')
